module.exports = __webpack_public_path__ + "img/home_image_liucheng@2x.1e0676f8.png";